function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEyeFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.22 13.93a5 5 0 110 10 5 5 0 010-10zM16.26 9c10.684 0 14.136 10.509 14.17 10.63l-1.91.6C28.4 19.85 25.47 11 16.25 11 7.03 11 4.03 19.86 3.9 20.24L2 19.62C2.03 19.52 5.57 9 16.26 9zm.74 7a2 2 0 100 4 2 2 0 000-4z",
    fill: props.color
  }));
}

export default SvgIconEyeFilled;